<template>
  <div class="contact-root">
    <form class="contact-form" @submit="handleSubmit">
      <h2 class="contact-title">联系我们</h2>
      <div class="contact-subtitle">有任何建议或需要帮助吗？请联系我们，我们很重视您的反馈，并竭诚为您服务。</div>
      <div class="form-group">
        <label>姓名/电话/微信</label>
        <input v-model="name" type="text" placeholder="请输入您的姓名、电话或微信号" />
      </div>
      <div class="form-group">
        <label>问题类型</label>
        <select v-model="type">
          <option value="">请选择</option>
          <option value="咨询">咨询</option>
          <option value="建议">建议</option>
          <option value="投诉">投诉</option>
          <option value="其他">其他</option>
        </select>
      </div>
      <div class="form-group">
        <label>您遇到什么问题？</label>
        <textarea v-model="content" rows="5" placeholder="请详细描述您遇到的问题或您要咨询的内容"></textarea>
      </div>
      <div class="form-tip">
        继续即表示您同意我们的 <a href="#" @click.prevent="openTerms">《服务条款》</a> 和 <a href="#" @click.prevent="openPrivacyPolicy">《隐私政策》</a>
      </div>
      <div style="text-align:right;">
        <button class="submit-btn" type="submit" :disabled="isSubmitting">
          {{ isSubmitting ? '提交中...' : '发送' }}
        </button>
      </div>
    </form>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { submitFeedback } from '@/api/admin'

const route = useRoute()
const router = useRouter()
const name = ref('')
const type = ref('')
const content = ref('')
const isSubmitting = ref(false)

function openTerms() {
  router.push('/terms')
}

function openPrivacyPolicy() {
  router.push('/privacy')
}

// 提交反馈
async function handleSubmit(event) {
  event.preventDefault()
  
  // 表单验证
  if (!name.value.trim()) {
    alert('请输入您的姓名、电话或微信号')
    return
  }
  
  if (!type.value) {
    alert('请选择问题类型')
    return
  }
  
  if (!content.value.trim()) {
    alert('请详细描述您遇到的问题')
    return
  }
  
  if (isSubmitting.value) return
  
  isSubmitting.value = true
  
  try {
    const feedbackData = {
      name: name.value.trim(),
      type: type.value,
      content: content.value.trim()
    }
    
    await submitFeedback(feedbackData)
    alert('反馈提交成功！我们会尽快回复您。')
    
    // 清空表单
    name.value = ''
    type.value = ''
    content.value = ''
    
  } catch (error) {
    console.error('提交反馈失败:', error)
    alert('提交失败，请稍后重试')
  } finally {
    isSubmitting.value = false
  }
}

onMounted(() => {
  document.title = '聚宝铺-联系我们'
})
</script>

<style scoped>
.contact-root {
  min-height: 100vh;
  background: #f7faff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.contact-form {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 8px 48px #2979ff11;
  padding: 48px 36px 32px 36px;
  color: #222;
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.contact-title {
  color: #2979ff;
  font-size: 2.6rem;
  text-align: center;
  margin-bottom: 8px;
  font-weight: bold;
  letter-spacing: 2px;
}
.contact-subtitle {
  color: #2979ff;
  text-align: center;
  font-size: 1.08rem;
  margin-bottom: 18px;
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.form-group label {
  color: #2979ff;
  font-size: 1.08rem;
  margin-bottom: 2px;
}
input, select, textarea {
  background: #fff;
  border: 1.5px solid #2979ff44;
  border-radius: 8px;
  color: #222;
  padding: 12px 14px;
  font-size: 1rem;
  outline: none;
  transition: border 0.2s, box-shadow 0.2s;
  box-shadow: 0 1px 8px #2979ff11;
}
input:focus, select:focus, textarea:focus {
  border: 1.5px solid #2979ff;
  box-shadow: 0 0 0 2px #2979ff33;
}
select {
  appearance: none;
  -webkit-appearance: none;
  background-image: url('data:image/svg+xml;utf8,<svg fill="%232979ff" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M7.293 7.293a1 1 0 011.414 0L10 8.586l1.293-1.293a1 1 0 111.414 1.414l-2 2a1 1 0 01-1.414 0l-2-2a1 1 0 010-1.414z"/></svg>');
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 18px 18px;
}
textarea {
  min-height: 100px;
  resize: vertical;
}
.form-tip {
  color: #2979ff;
  font-size: 0.98rem;
  margin-top: 8px;
  text-align: left;
}
.form-tip a {
  color: #2979ff;
  text-decoration: underline;
  margin: 0 2px;
}
.submit-btn {
  background: linear-gradient(90deg, #4ba3fa 0%, #2979ff 100%);
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 12px 36px;
  font-size: 1.15rem;
  font-weight: bold;
  cursor: pointer;
  margin-top: 12px;
  box-shadow: 0 2px 12px #2979ff33;
  transition: background 0.2s, box-shadow 0.2s;
  display: inline-block;
}
.submit-btn:hover:not(:disabled) {
  background: linear-gradient(90deg, #2979ff 0%, #4ba3fa 100%);
  box-shadow: 0 4px 24px #2979ff44;
}

.submit-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
  box-shadow: none;
}
@media (max-width: 700px) {
  .contact-root {
    align-items: flex-start;
    padding-left: 24px;
    padding-right: 24px;
    box-sizing: border-box;
    padding-top: 24px;
    padding-bottom: 8px;
  }
  .contact-form {
    padding: 18px 16px 10px 16px;
    border-radius: 12px;
    margin: 0 auto;
    max-width: 100%;
    box-sizing: border-box;
    gap: 8px;
  }
  .contact-title {
    font-size: 1.35rem;
    margin-bottom: 12px;
    margin-top: 0;
  }
  .contact-subtitle {
    font-size: 0.98rem;
    margin-bottom: 10px;
  }
  .form-group {
    gap: 4px;
  }
  .form-group label {
    font-size: 0.98rem;
  }
  input, select, textarea {
    font-size: 1.05rem;
    padding: 16px 14px;
    border-radius: 12px;
  }
  .submit-btn {
    font-size: 1rem;
    padding: 10px 0;
    border-radius: 12px;
    width: 80%;
    min-width: 100px;
    max-width: 320px;
    margin: 16px auto 0 auto;
    display: block;
  }
  .form-tip {
    font-size: 0.92rem;
    margin-top: 4px;
  }
}
</style> 